export const truncateText = (text = '', limit = 50) => {
    if (!text) return '';
    return text.length > limit ? text.slice(0, limit) + '....' : text;
  };

export function toCamelCase(str) {
    return str
      .replace(/[-_]+/g, ' ')                // replace - and _ with space
      .replace(/[^\w\s]/g, '')               // remove non-word characters
      .trim()                                // remove leading/trailing spaces
      .split(/\s+/)                          // split by one or more spaces
      .map((word, index) => {
        if (index === 0) {
          return word.toLowerCase();         // lowercase first word
        }
        return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(); // capitalize others
      })
      .join('');
  }
  

  export function toSentenceCase(str) {
    const trimmed = str.trim();
    if (!trimmed) return '';

    if (trimmed.toLowerCase() === 'inprogress' || trimmed.toLowerCase() === 'in progress') return 'In Progress';
    if (trimmed.toLowerCase() === 'attach atr') return 'Attach ATR';
  
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1).toLowerCase();
  }
  